import React from 'react';
import SearchBox from './search';

function SearchTop() {
  return (
    <div className="search-top">
      <SearchBox />
    </div>
  );
}

export default SearchTop;
